import type { BrandRole } from "@/core/brand/brand-context";

/** What each role can do, in words (the API's Owner / Manager / Staff rules, API.md §7). */
export const ROLE_CHOICES: readonly { value: BrandRole; label: string; detail: string }[] = [
  { value: "OWNER", label: "Owner", detail: "Everything, including earnings, payouts and the team" },
  {
    value: "MANAGER",
    label: "Manager",
    detail: "Menus, plans, customers and dispatch; not money or the team",
  },
  { value: "STAFF", label: "Staff", detail: "Only Orders and Dispatch: what to cook and deliver" },
];

/** A plain check before sending (the API checks the address properly). */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * A member whose account isn't active (API `accountStatus`): the role can't change, they can only be removed.
 * Null for active accounts.
 */
export function accountNote(status: string): { label: string; detail: string } | null {
  if (status === "DELETION_REQUESTED")
    return {
      label: "Leaving Brocoly",
      detail: "Their account is being deleted. You can remove them, but not change their role.",
    };
  if (status === "SUSPENDED")
    return {
      label: "Suspended",
      detail: "Brocoly suspended their account. You can remove them, but not change their role.",
    };
  return null;
}
